<template>
  <div class="">
    <hybrid-mail> </hybrid-mail>
  </div>
</template>

<script>
import HybridMail from "@/components/log/hybrid-mail/index.vue";
import { mapActions } from "vuex";
export default {
  props: {
    msg: String,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    HybridMail,
  },
  created() {
    this.notifyQueue({
      text: "Posta Ibrida",
      path: "module.LOG.LIBR",
      level: 1,
    });
  },
};
</script>
